import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { title: 'Active', link: 'active-patients' },
  { title: 'Invitations', link: 'invited-patients' },
];

export function PatientLayout() {
  return (
    <div className="ml-4 mt-5">
      <div className="mt-14 flex  justify-around">
        <div>
          <div className="mt-2 flex w-max cursor-pointer flex-col text-base font-semibold text-background-contrastText">
            {tabs.map((tab) => (
              <NavLink
                to={tab.link}
                className={({ isActive }) =>
                  `inline-block py-4  pl-1 text-md  ${
                    isActive
                      ? 'text-primary-main '
                      : 'text-background-contrastText '
                  }`
                }>
                {tab.title}
              </NavLink>
            ))}
          </div>
        </div>
        <span className="mx-8 h-[8rem] w-[2px] bg-background-light" />
        <div className="grow">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
